import { Component, Input, Output, EventEmitter } from '@angular/core';

export type LabelPosition = 'left' | 'above';

@Component({
  selector: 'app-toggle-switcher',
  templateUrl: './toggle-switcher.component.html',
  styleUrls: ['./toggle-switcher.component.scss']
})
export class ToggleSwitcherComponent {
  @Input() label: string = '';
  @Input() value: boolean = false;
  @Input() clickableRow: boolean = false;
  @Input() disabled: boolean = false;
  @Input() labelPosition: LabelPosition = 'left';

  @Output() onChange = new EventEmitter<boolean>();

  toggle(): void {
    if (this.disabled) return;
    this.value = !this.value;
    this.onChange.emit(this.value);
  }

  onKeydown(event: KeyboardEvent): void {
    if (this.disabled) return;
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.toggle();
    }
  }
}
